import { Segmented } from '../ui'
import { KIND_OPTIONS } from '../lib/listKinds'
import type { ListKind } from '../lib/types'

/**
 * The five list kinds, all on screen at once: two rows of a fixed grid
 * (`.lists-kinds` in `app.css`). It used to be one `Segmented` track in a
 * sideways scroller, which at 390px showed "Che" for Checklist and at 360px
 * hid it entirely, with nothing saying there was more (UI-audit a2-16). The
 * grid is fixed — three over two at every width — so no option moves when
 * the sheet is wider or narrower, which is what the scroller was avoiding.
 * One component for the three pickers (New list, Change kind, Add to list's
 * new-list form) so they cannot drift apart again.
 */
export function KindPicker({ value, onChange, options = KIND_OPTIONS }: {
  value: ListKind
  onChange: (kind: ListKind) => void
  /** A narrower set, still in `KIND_OPTIONS` order — Add to list offers only
   *  the kinds an event fits (a2-23). */
  options?: typeof KIND_OPTIONS
}) {
  return (
    <Segmented
      className="lists-kinds" aria-label="Kind"
      value={value} onChange={v => onChange(v as ListKind)} options={options}
    />
  )
}
